import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MergePurgeParameters } from './types/merge-purge-parameters.type';
import type { SuppressionFile } from './types/suppression-file.type';

/**
 * Fetches suppression files for merge-purge operations using the provided HTTP client instance and search parameters.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param searchParams - The parameters used to filter or search for suppression files.
 * @returns A promise that resolves to an {@link OperationResultWithData} containing an array
 * of {@link SuppressionFile}.
 * @throws Will throw an error if the request fails.
 */
export const getSuppressionFiles = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<SuppressionFile[]>>(Uri.reports.mergePurge.suppressionFiles, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
